import axios from 'axios';

// API Base URL - später aus .env laden
// Trailing-Slashes entfernen, sonst entstehen doppelte Slashes ("//api/file/..."),
// die das Backend mit 404 quittiert.
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/+$/, '');

// Axios-Instanz mit Basis-Konfiguration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor für Auth-Token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dc-sign');
  if (token) {
    config.headers['dc-sign'] = token;
  }
  return config;
});

// Response Interceptor für Error Handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('dc-sign');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;